import React, { type JSX } from "react";
// import PinIcon from "@vector-im/compound-design-tokens/assets/web/icons/pin-solid";
import {Icon as PinIcon} from "../../../../res/customIcons/pinned-message-neg-icon.svg";

import { _t } from "../../../languageHandler";

/**
 * A badge to indicate that a message is pinned.
 */
export function PinnedMessageBadge(): JSX.Element {
    return (
        <div className="mx_PinnedMessageBadge">
            <PinIcon width="16px" height="16px" />
            {_t("room.pinned_message_badge")}
        </div>
    );
}
